import { Navigate, Outlet } from "react-router-dom";
import AuthLayout from "../components/layout";
import { useAuth, useStorageManager } from "../shared/hooks";

const AuthRoute: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const { getFromLocalStorage } = useStorageManager();

  const userDetails = getFromLocalStorage("userDetails") ? JSON.parse(getFromLocalStorage("userDetails")!) : null;
  const isNewUserDetails = getFromLocalStorage("isNewUserDetails") ? JSON.parse(getFromLocalStorage("isNewUserDetails")!) : null;

  // If user is authenticated and has completed setup, redirect to dashboard
  if (isAuthenticated() && userDetails && isNewUserDetails) {
    return <Navigate to="/dashboard" replace />;
  }

  // If user is authenticated but hasn't completed setup, allow access to auth routes
  return (
    <AuthLayout>
      <Outlet />
    </AuthLayout>
  );
};

export default AuthRoute;
